import { environment } from "@env/environment";
import { BaseModel } from "./base.model";

export class Image extends BaseModel {
    id!: string;
    url!: string;
    baseUrl!: string;
    size?: number;
    width?: number;
    height?: number;
    originalName?: string;

    get imageUrl() {
        return this.getImageUrl();
    }

    getImageUrl(spec = 'w1200_h800'): string {
        if (this.url) {
            return this.url;
        }

        if (this.id) {
            return `${environment.apiBaseUrl}/images/${this.id}?spec=${spec}`;
        }

        if (this.baseUrl) {
            return `${this.baseUrl}?spec=${spec}`;
        }

        return '/assets/img/icons/gallery.svg';
    }
}